import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Chip,
} from "@mui/material";

const DevIdeFileListPanel = ({
  filesLoading,
  filesError,
  filteredFiles,
  selectedFileId,
  onSelectFile,

  // NEW: optional props for change tracking
  activeChangeId,
  changeFiles, // array of { file_path, ... }
}) => {
  if (filesLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (filesError) {
    return (
      <Box p={2}>
        <Typography color="error" variant="body2">
          Error loading files: {filesError}
        </Typography>
      </Box>
    );
  }

  if (!filteredFiles || !filteredFiles.length) {
    return (
      <Box p={2}>
        <Typography variant="body2">No files found.</Typography>
      </Box>
    );
  }

  // NEW: build set of file paths that belong to active change
  const changePaths = new Set(
    (changeFiles || []).map((cf) => cf.file_path)
  );

  return (
    <List dense sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
      {filteredFiles.map((f) => {
        const isInChange =
          activeChangeId &&
          changePaths.has(f.path);

        return (
          <React.Fragment key={f.id}>
            <ListItemButton
              selected={selectedFileId === f.id}
              onClick={() => onSelectFile(f.id)}
            >
              <ListItemText
                primary={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="body2" noWrap>
                      {f.path}
                    </Typography>

                    {/* NEW: In-change indicator */}
                    {isInChange && (
                      <Chip
                        size="small"
                        label="In change"
                        color="info"
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Box>
                }
                secondary={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {f.module}
                      {f.description ? ` - ${f.description}` : ""}
                    </Typography>

                    <Chip
                      size="small"
                      label={f.is_patch_friendly ? "Patch-friendly" : "Large file"}
                      color={f.is_patch_friendly ? "success" : "warning"}
                      sx={{ ml: 1 }}
                    />
                  </Box>
                }
              />
            </ListItemButton>
            <Divider component="li" />
          </React.Fragment>
        );
      })}
    </List>
  );
};

export default DevIdeFileListPanel;
